import {BaseDTO} from '../../../common/models/BaseDTO';
import {CodingSchemaDTO} from '../../../ent/models/CodingSchemaDTO';

export class CaseHospitalCodingSchemaLinkDTO extends BaseDTO {
  codingSchema: CodingSchemaDTO;
  startDate: Date;
  endDate: Date;
  procedureTier: string;
}